import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {ProgramDelegateModel} from '../../models/program.model';
@Component({
    selector: 'app-journey-list-template-course-overview',
    templateUrl: './list-template-course-overview.component.html',
    styleUrls: ['./list-template-course-overview.component.scss']
})
export class LearningJourneyListTemplateCourseOverviewComponent implements OnInit {
    title: string = null;
    icon: string = null;
    description: string = null;

    @Input() embedded = false;
    @Input() readonly = false;
    @Input() courseOverview = null;

    constructor() {
    }

    ngOnInit() {
    }

}
